module.exports = ".min-md-width{width:100%}\n"